import React from 'react'
// @ts-ignore no types
import { connect } from 'react-redux'
import {
  Grid,
  TutorialTooltip,
  hooks,
  // @ts-ignore no types
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import type { primitives } from '@adc/blueprint'
import SectionPanel from '../../components/sectionPanel'
import { toggleNewContactModal } from '../../actions/modals'
import { withModalHooks } from '../../hooks/useModalFeatures'
import { usePropertyContext } from '../../context/property'
import { useListingContext } from '../../context/listing'
import { useContactModal } from './useContactModal'
import PropertyDetailsRow from './propertyDetailsRow'
import SpecialNotes from './specialNotes'
import Badges from './badges'
// @ts-ignore no types
import cls from './index.scss'

const cx = classnames.bind(cls)

interface PropertyDetailsProps {
  badgeActions: {
    toggleContactModal: (args?: any) => void
    toggleSaveProperty: (saveData: any) => void
  }
  user: primitives.AuctionUser
  pushAuthQueueItem: () => void
  pushOnboardingQueueItem: (args: any[]) => void
  toggleAuthModal: () => void
  hideBadges: boolean
  // TODO: hideDetails is a temporary prop meant to show how the section looks
  // when removing the detailsRow and specialNotes while working on
  // Private Seller template.
  // Once we have built the new badges section we have no more need of it and
  // should remove it
  hideDetails: boolean
}

const PropertyDetails = ({
  badgeActions,
  pushAuthQueueItem,
  pushOnboardingQueueItem,
  toggleAuthModal,
  user,
  hideBadges,
  hideDetails,
}: PropertyDetailsProps) => {
  // @ts-ignore no types TODO When we export AuthenticatedAuctionUser from types.d.ts then we can type this
  const contactModal = useContactModal({ user })
  const { listing } = useListingContext()
  const { property, propertyActions } = usePropertyContext()
  const isFirstLookEnabled =
    listing?.listing_configuration?.is_first_look_enabled

  const openContactModal = () => {
    setTimeout(() => contactModal.open(), 10)
  }

  const toggleContactModalIfLogged = () => {
    if (user.logged_in) {
      openContactModal()
    } else {
      toggleAuthModal()
      pushOnboardingQueueItem([openContactModal])
    }
  }

  const toggleSaveProperty = (args: any) =>
    propertyActions?.toggleSaveProperty({
      ...args,
      listing,
      property,
      pushAuthQueueItem,
      toggleAuthModal,
    })

  const newBadgeActions = {
    ...badgeActions,
    toggleSaveProperty,
    toggleContactModal: toggleContactModalIfLogged,
  }
  const specialNotes =
    listing.listing_remarks?.special_notes ||
    listing.listing_remarks?.mls_comment ||
    ''
  const propertyDetailsContent = (
    <>
      {!hideDetails && <PropertyDetailsRow listing={listing} />}
      {!hideBadges && (
        <TutorialTooltip
          elmId='property_details_tutorial_tooltip'
          tutorial={3}
          header='See Property Details'
          position='right center'
          content='Get details on payment types, vacancy and interior access.'
        >
          <Badges badgeActions={newBadgeActions} listing={listing} />
        </TutorialTooltip>
      )}
    </>
  )

  const isMobile = hooks.useIsMobileHook()

  return (
    <>
      <SectionPanel
        elmId='property_details'
        title={!hideDetails ? 'Property Details' : ''}
        collapsible={false}
        highlighted
      >
        <Grid>
          <Grid.Column
            computer={10}
            tablet={8}
            mobile={16}
            className={cx({
              'property-details-container': isFirstLookEnabled,
            })}
          >
            {propertyDetailsContent}
          </Grid.Column>
        </Grid>
        {!isMobile && !hideDetails && <SpecialNotes notes={specialNotes} />}
      </SectionPanel>
      {isMobile && !hideDetails && specialNotes && specialNotes.trim() !== '' && (
        <div className={cx('mobile-special-notes')}>
          <SectionPanel elmId='special_notes' collapsible={false}>
            <div className={cx('special-notes-container')}>
              <SpecialNotes notes={specialNotes} />
            </div>
          </SectionPanel>
        </div>
      )}
    </>
  )
}

const mapStateToProps = (store: any) => ({
  featureFlags: store.featureFlags,
  user: store.user,
})

const mapDispatchToProps = (dispatch: any) => ({
  badgeActions: {
    toggleContactModal: (args?: any) => dispatch(toggleNewContactModal(args)),
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withModalHooks(PropertyDetails))
